import { render, staticRenderFns } from "./TinyMCE.vue?vue&type=template&id=51404180&"
import script from "./TinyMCE.vue?vue&type=script&lang=js&"
export * from "./TinyMCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51404180')) {
      api.createRecord('51404180', component.options)
    } else {
      api.reload('51404180', component.options)
    }
    module.hot.accept("./TinyMCE.vue?vue&type=template&id=51404180&", function () {
      api.rerender('51404180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/TinyMCE.vue"
export default component.exports